import { linePlot, periodInput } from "../definitionHelpers";
import { PALETTE } from "../palette";
import { zigZagPivots } from "../math/zigZag";

const isSameValue = (value, other) => value === other || (Number.isNaN(value) && Number.isNaN(other));

// The line through the pivots, one value per bar (straight between two pivots), NaN outside them
const lineThroughPivots = (pivots) => {
  const line = new Array(pivots.length).fill(NaN);
  let previous = -1;

  pivots.forEach((price, index) => {
    if (price === 0) return;

    for (let position = previous + 1; previous >= 0 && position < index; position += 1) {
      line[position] = pivots[previous] + ((price - pivots[previous]) * (position - previous)) / (index - previous);
    }

    line[index] = price;
    previous = index;
  });

  return line;
};

/**
 * ZigZag (research §1.4): the MetaTrader ZigZag (math/zigZag.js), whose
 * inputs PO has; Deviation is in points (the price step of the pair).
 * A new bar may move the last pivots, so every calculation goes over all
 * bars (fast: about Depth reads per bar) and reports the first changed value.
 * `pivots` holds the turning points, NaN elsewhere.
 */
export default {
  id: "zigzag",
  name: "ZigZag",
  isOscillator: false,
  inputs: [
    periodInput("deviation", "Deviation", 5, { max: 100 }),
    periodInput("depth", "Depth", 12, { max: 100 }),
    periodInput("backstep", "Backstep", 3, { max: 100 }),
  ],
  plots: [
    linePlot("value", "Line", PALETTE.LIME, { width: 2 }),
  ],
  buffers: ["pivots"],
  levels: [],

  calculate: (bars, { deviation, depth, backstep }, series, fromIndex, { priceStep }) => {
    const pivots = zigZagPivots(bars, { depth, backstep, deviation: deviation * priceStep });
    const line = lineThroughPivots(pivots);
    let firstChanged = fromIndex;

    for (let index = bars.length - 1; index >= 0; index -= 1) {
      const pivot = pivots[index] === 0 ? NaN : pivots[index];

      if (!isSameValue(series.value[index], line[index]) || !isSameValue(series.pivots[index], pivot)) {
        firstChanged = Math.min(firstChanged, index);
      }

      series.value[index] = line[index];
      series.pivots[index] = pivot;
    }

    return firstChanged;
  },
};
